var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CContainer',{attrs:{"fluid":""}},[_c('div',{staticClass:"metro-menu"},[_c('div',{staticClass:"tile tile-12 small"},[_c('i',{staticClass:"bi bi-basket"}),_c('span',[_vm._v("Ordenes de Compra")])]),_c('div',{staticClass:"tile tile-2 small",on:{"click":(e) => {
        e.preventDefault()
        e.stopPropagation();
        _vm.$router.push({ path: `${_vm.rootPath}/facturascompra` });
      }}},[_c('i',{staticClass:"bi bi-bag-check"}),_c('span',[_vm._v("Facturas de Compra")])]),_c('div',{staticClass:"tile tile-6 small",on:{"click":(e) => {
        e.preventDefault()
        e.stopPropagation();
        _vm.$router.push({ path: `${_vm.rootPath}/documentossoporte` });
      }}},[_c('i',{staticClass:"bi bi-clipboard-check"}),_c('span',[_vm._v("Documentos Soporte")])]),_c('div',{staticClass:"tile tile-10 medium",on:{"click":(e) => {
        e.preventDefault()
        e.stopPropagation();
        _vm.$router.push({ path: `${_vm.rootPath}/recepciondocumentoselectronicos` });
      }}},[_c('i',{staticClass:"bi bi-filetype-xml"}),_c('span',[_vm._v("Recepción Documentos Electrónicos")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }